// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

export function isMultilineAuditValue(value: unknown): value is string {
  return typeof value === 'string' && /(?:\r\n|\r|\n)/.test(value);
}
